/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const thMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 สงวนลิขสิทธิ์',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'เข้าสู่ระบบ',
  'user.register': 'ลงทะเบียน',
  'user.forgot-password': 'ลืมรหัสผ่าน',
  'user.email': 'อีเมล',
  'user.newpassword': 'รหัสผ่านใหม่',
  'user.currentpassword': 'รหัสผ่านปัจจุบัน',
  'user.newpasswordagain': 'รหัสผ่านใหม่อีกครั้ง',
  'user.password': 'รหัสผ่าน',
  'user.forgot-password-question': 'ลืมรหัสผ่าน?',
  'user.fullname': 'ชื่อเต็ม',
  'user.firstname': 'First Name',
  'user.lastname': 'Last Name',
  'user.login-button': 'LOGIN',
  'user.register-button': 'REGISTER',
  'user.reset-password-button': 'RESET',
  'user.buy': 'BUY',
  'user.username': 'Username',

  /* 03.Menu */
  'menu.app': 'Home',

  'menu.default': 'Default',
  'menu.analytics': 'Analytics',
  'menu.ecommerce': 'Ecommerce',
  'menu.content': 'Content',
  'menu.pages': 'Pages',
  'menu.data-list': 'Data List',
  'menu.thumb-list': 'Thumb List',
  'menu.image-list': 'Image List',
  'menu.details': 'Details',
  'menu.search': 'Search',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.forgot-password': 'Forgot Password',
  'menu.error': 'Error',
  'menu.applications': 'Applications',
  'menu.todo': 'To-do List',
  'menu.survey': 'Survey',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Edit',
  'menu.alerts': 'Alerts',
  'menu.badges': 'Badges',
  'menu.buttons': 'Buttons',
  'menu.cards': 'Cards',
  'menu.carousel': 'Carousel',
  'menu.charts': 'Charts',
  'menu.collapse': 'Collapse',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editors',
  'menu.form-layouts': 'Form Layouts',
  'menu.form-components': 'Form Components',
  'menu.form-validations': 'Form Validations',
  'menu.icons': 'Icons',
  'menu.input-groups': 'Input Groups',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortable',
  'menu.tables': 'Tables',
  'menu.menu': 'Menu',
  'menu.subhidden': 'Subhidden',
  'menu.hidden': 'Hidden',
  'menu.visible': 'Visible',
  'menu.maps': 'Maps',
  'menu.landingpage': 'Landing Page',
  'menu.multipage-home': 'Multipage Home',
  'menu.singlepage-home': 'Singlepage Home',
  'menu.about': 'About',
  'menu.auth-login': 'Auth Login',
  'menu.auth-register': 'Auth Register',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blog Detail',
  'menu.careers': 'Careers',
  'menu.confirmation': 'Confirmation',
  'menu.contact': 'Contact',
  'menu.docs': 'Docs',
  'menu.features': 'Features',
  'menu.prices': 'Prices',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Invoice',
  'menu.blank-page': 'Coming soon...',
  'menu.types': 'Menu Types',
  'menu.levels': 'Menu Levels',
  'menu.third-level-1': 'Third Level 1',
  'menu.third-level-2': 'Third Level 2',
  'menu.third-level-3': 'Third Level 3',

  /* 04.Dashboards */
  'dashboards.update': 'อัปเดต',
  'dashboards.save': 'บันทึก',
  'dashboards.saveSchedule': 'บันทึกตารางเวลา',
  'dashboards.pending-orders': 'Pending Orders',
  'dashboards.completed-orders': 'Completed Orders',
  'dashboards.refund-requests': 'Refund Requests',
  'dashboards.new-comments': 'New Comments',
  'dashboards.sales': 'Sales',
  'dashboards.orders': 'Orders',
  'dashboards.refunds': 'Refunds',
  'dashboards.recent-orders': 'Recent Orders',
  'dashboards.product-categories': 'Product Categories',
  'dashboards.cakes': 'Cakes',
  'dashboards.tickets': 'ตั๋ว',
  'dashboards.calendar': 'Calendar',
  'dashboards.best-sellers': 'Best Sellers',
  'dashboards.per-session': 'Per Session',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Payment Status',
  'dashboards.work-progress': 'Work Progress',
  'dashboards.tasks-completed': 'Tasks Completed',
  'dashboards.payments-done': 'Payments Done',
  'dashboards.order-stock': 'Order - Stock',
  'dashboards.categories': 'Categories',
  'dashboards.quick-post': 'Quick Post',
  'dashboards.title': 'Title',
  'dashboards.content': 'Content',
  'dashboards.ticket-count': 'จำนวนตั๋ว',
  'dashboards.commonticketsubmission': 'การส่งตั๋วที่พบบ่อย',
  'dashboards.category': 'Category',
  'dashboards.save-and-publish': 'Save and Publish',
  'dashboards.top-viewed-posts': 'Top Viewed Posts',
  'dashboards.posts': 'Posts',
  'dashboards.pending-for-publish': 'Pending for publish',
  'dashboards.users': 'Users',
  'dashboards.on-approval-process': 'On approval process',
  'dashboards.alerts': 'Alerts',
  'dashboards.waiting-for-notice': 'Waiting for notice',
  'dashboards.files': 'Files',
  'dashboards.pending-for-print': 'Pending for print',
  'dashboards.logs': 'Logs',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'MAGIC IS IN THE DETAILS',
  'dashboards.yes-it-is-indeed': 'Yes, it is indeed!',
  'dashboards.advanced-search': 'Advanced Search',
  'dashboards.toppings': 'Toppings',
  'dashboards.type': 'Type',
  'dashboards.keyword': 'Keyword',
  'dashboards.search': 'Search',
  'dashboards.top-rated-items': 'Top Rated Items',
  'dashboards.country': 'ประเทศ',
  'dashboards.webVisitors': 'ผู้เข้าชมเว็บไซต์',
  'dashboards.avatarClicks': 'การคลิกอวาตาร์',
  'dashboards.wordCloud': 'เมฆคำ',
  'dashboards.topic': 'หัวข้อ',
  'dashboards.name': 'ชื่อ',
  'dashboards.button': 'ปุ่ม',
  'dashboards.visits': 'เยี่ยมชม',
  'dashboards.checkAvailability': 'ตรวจสอบความพร้อมใช้งานหรือราคา',
  'dashboards.details': 'รายละเอียด',
  'dashboards.roomsAvailability': 'ห้องพักและความพร้อมใช้งาน',
  'dashboards.startChat': 'เริ่มแชท',
  'dashboards.restaurantsBars': 'ร้านอาหารและบาร์',
  'dashboards.groupBooking': 'การจองแบบกลุ่ม',
  'dashboards.promotions': 'โปรโมชั่น',
  'dashboards.weedingevents': 'งานแต่งงาน & อีเวนต์',
  'dashboards.lostsomething': 'ทำของหาย',
  'dashboards.producttext': 'ข้อความสินค้า',
  'dashboards.bookingroomnew': 'จองห้องใหม่',
  'dashboards.email': 'อีเมล',
  'dashboards.phone': 'โทรศัพท์',
  'dashboards.zipcode': 'รหัสไปรษณีย์',
  'dashboards.marketingconsent': 'ความยินยอมทางการตลาด',
  'dashboards.additionalinfo': 'ข้อมูลเพิ่มเติม',
  'dashboards.viewallcontacts': 'ดูผู้ติดต่อทั้งหมด',
  'dashboards.current': 'ปัจจุบัน',
  'dashboards.last7days': 'ย้อนหลัง 7 วัน',
  'dashboards.last30days': 'ย้อนหลัง 30 วัน',
  'dashboards.thisweek': 'สัปดาห์นี้',
  'dashboards.thismonth': 'เดือนนี้',
  'dashboards.previousmonth': 'เดือนที่ผ่านมา',
  'dashboards.yeartodate': 'ตั้งแต่ต้นปีถึงปัจจุบัน',
  'dashboards.lastyear': 'ปีที่แล้ว',
  'dashboards.all': 'ทั้งหมด',
  'dashboards.standardOccupancy': 'จำนวนผู้เข้าพักมาตรฐาน',
  'dashboards.max-occupancy': 'จำนวนผู้เข้าพักสูงสุด',
  'dashboards.numberOfThisType': 'จำนวนประเภทนี้',
  'dashboards.displayOrder': 'ลำดับการแสดงผล',
  'dashboards.provider': 'ผู้ให้บริการ',
  'dashboards.edit': 'แก้ไข',
  'dashboards.delete': 'ลบ',
  'dashboards.addImages': 'เพิ่มรูปภาพ',
  'dashboards.location_ip': 'ตำแหน่งโดยประมาณ โดยอิงจากที่อยู่ IP',
  'dashboards.near': 'ใกล้เคียง',
  'dashboards.referral': 'ผู้ใช้ถูกแนะนำมาจากเว็บไซต์นี้',
  'dashboards.calling_party': 'ผู้โทร',
  'dashboards.called_party': 'ผู้รับสาย',
  'dashboards.lastdial': 'การโทรล่าสุด',
  'dashboards.imagelink': 'ลิงก์รูปภาพ',
  'dashboards.browsegallery': 'เรียกดูแกลเลอรี',
  'dashboards.changelog': 'บันทึกการเปลี่ยนแปลง',
  'dashboards.externalresources': 'แหล่งข้อมูลภายนอก',
  'dashboards.webpage': 'หน้าเว็บ',
  'dashboards.web-pages': 'หน้าเว็บ',
  'dashboards.published': 'เผยแพร่แล้ว',
  'dashboards.adddocument': 'เพิ่มเอกสาร',
  'dashboards.ready-to-publish': 'พร้อมเผยแพร่',
  'dashboards.draft': 'ร่าง',
  'dashboards.order-by': 'เรียงตาม',
  'dashboards.add-faq': 'เพิ่มคำถามที่พบบ่อย',
  'dashboards.collections': 'คอลเลกชัน',
  'dashboards.items': 'รายการ',
  'dashboards.rooms-availability': 'ห้องพักและความพร้อม',
  'dashboards.events-wedding-venues': 'กิจกรรมและสถานที่จัดงานแต่งงาน',
  'dashboards.long-stay-enquiry': 'สอบถามการเข้าพักระยะยาว',
  'dashboards.reservation-confirmation-request': 'คำขอยืนยันการจอง',
  'dashboards.modify-cancel-booking': 'แก้ไขหรือยกเลิกการจอง',
  'dashboards.left-something-behind': 'ลืมของไว้',
  'dashboards.invoice-copy': 'สำเนาใบแจ้งหนี้ / ใบเสร็จ',
  'dashboards.sync': 'ซิงค์',
  'dashboards.syncNow': 'ซิงค์ตอนนี้',
  'dashboards.add-web-page': 'เพิ่มหน้าเว็บ',
  'dashboards.sprint-title':
    'แนะนำ Sprint ระบบอัตโนมัติขั้นสูงของเราเพื่อฝึกโมเดล AI ให้เร็วขึ้น 10 เท่า',
  'dashboards.sprint-description':
    'Sprint ทำงานเคียงข้างคุณ เพื่อปลดปล่อยความคิดสร้างสรรค์ เพิ่มผลิตภาพ และลดเวลาการฝึกผู้ช่วยดิจิทัลลงอย่างมาก',
  'dashboards.sprint-feature':
    'ฟีเจอร์ Sprint ถูกออกแบบมาเพื่อซิงค์ความรู้จากแหล่งข้อมูลภายนอก ซึ่งมีประโยชน์ทั้งสำหรับการตั้งค่าเริ่มต้นและการอัปเดตข้อมูลอย่างต่อเนื่อง เมื่อทำงานบนระบบที่เปิดใช้งาน Sprint จะปรับเปลี่ยน Knowledge Hub ตามแหล่งข้อมูลภายนอกที่คุณตั้งค่า ซึ่งสามารถส่งผลโดยตรงต่อพฤติกรรมและการตอบสนองที่สร้างโดย AI หากต้องการความช่วยเหลือในการตั้งค่า Sprint กรุณาติดต่อทีมสนับสนุนของเรา',
  'dashboards.change-password': 'เปลี่ยนรหัสผ่าน',
  'dashboards.sign-out': 'ออกจากระบบ',
  'dashboards.privacy-policy': 'นโยบายความเป็นส่วนตัว',
  'dashboards.help-center': 'ศูนย์ช่วยเหลือ',
  'dashboards.switch-account': 'สลับบัญชี',
  'dashboards.business-settings': 'การตั้งค่าธุรกิจ',
  'dashboards.notifications-allowed': 'อนุญาตการแจ้งเตือน',
  'dashboards.dark-theme': 'ธีมมืด',
  'dashboards.online': 'ออนไลน์',
  'dashboards.offline': 'ออฟไลน์',
  'dashboards.invoice-&-payments': 'ใบแจ้งหนี้ & การชำระเงิน',
  'dashboards.upgrade-plan': 'อัปเกรดแพลน',
  'dashboards.add-room': 'เพิ่มห้อง',
  'dashboards.room-type': 'ประเภทห้อง',
  'dashboards.room-name': 'ชื่อห้อง',
  'dashboards.how-many-guests': 'จำนวนผู้เข้าพักทั้งหมดต่อห้อง',
  'dashboards.number-of-rooms-this-type': 'จำนวนห้อง',
  'dashboards.number-of-bedrooms': 'จำนวนห้องนอน',
  'dashboards.number-of-livingrooms': 'จำนวนห้องนั่งเล่น',
  'dashboards.minimum-adults': 'ผู้ใหญ่ขั้นต่ำ',
  'dashboards.maximum-adults': 'ผู้ใหญ่สูงสุด',
  'dashboards.maximum-children': 'เด็กสูงสุด',
  'dashboards.maximum-infants': 'ทารกสูงสุด',
  'dashboards.extra-beds-allowed': 'อนุญาตเตียงเสริม',
  'dashboards.booking-engine-code': 'รหัสระบบจอง',
  'dashboards.room-size': 'ขนาดห้อง',
  'dashboards.balcony-area': 'พื้นที่ระเบียง',
  'dashboards.unit': 'หน่วย',
  'dashboard.whatsapp_message': 'พิมพ์ข้อความของคุณที่นี่...',
  'dashboard.whatsapp_reply_window':
    'คุณมีเวลา 24 ชั่วโมงในการตอบกลับข้อความของลูกค้าบน WhatsApp Business นับจากเวลาที่ลูกค้าส่งข้อความล่าสุด หากคุณตอบกลับภายในช่วงเวลาบริการลูกค้า 24 ชั่วโมงนี้ คุณสามารถส่งข้อความได้ทุกประเภท หลังจากช่วงเวลา 24 ชั่วโมงสิ้นสุดลง คุณจะสามารถส่งข้อความได้เฉพาะโดยใช้เทมเพลตข้อความที่ได้รับการอนุมัติล่วงหน้า ซึ่งจะเริ่มช่วงเวลา 24 ชั่วโมงใหม่เมื่อมีการตอบกลับจากลูกค้า',
  'dashboards.square-meters': 'ตารางเมตร',
  'dashboard.pick_quick_reply': 'เลือกคำตอบด่วนหรือพิมพ์ข้อความของคุณ',
  'dashboard.hang_in_there': 'โปรดรอสักครู่ ขณะเรากำลังพยายามเชื่อมต่อคุณ!',
  'dashboard.outbound_msg': 'เวลาที่จะส่งข้อความขาออก',
  'dashboard.message_sent': 'ส่งข้อความของคุณเรียบร้อยแล้ว!',
  'dashboard.failed_msg': 'ไม่สามารถส่งข้อความได้',
  'dashboard.new_chat_message': 'ข้อความแชทใหม่',
  'dashboard.user_msg':
    'มีข้อความจากผู้ใช้ภายใน 24 ชั่วโมงที่ผ่านมา คุณสามารถตอบกลับด้วยข้อความใดก็ได้ คุณยังต้องการส่งข้อความเทมเพลตนี้หรือไม่ หรือจะตอบกลับด้วยข้อความอื่น?',
  'dashboard.us_number':
    'ข้อความ WhatsApp Business จะไม่ถูกส่งไปยังหมายเลขในสหรัฐฯ เนื่องจาก Meta ได้หยุดข้อความทางการตลาดทั้งหมดไปยังหมายเลขในสหรัฐฯ ตั้งแต่วันที่ 1 เมษายน 2025',
  'dashboard.error_msg': 'กรุณากรอกช่องตัวแทนทั้งหมดให้ถูกต้อง',

  'web-widget.title': 'เมนูวิดเจ็ตเว็บสำหรับแชทบอทของเว็บไซต์',
  /*Home page*/
  'dashboards.quickstartwithai': 'เริ่มต้นอย่างรวดเร็วด้วย AI',
  'dashboards.fastestpathtoautomation':
    'คุณอยู่บนเส้นทางที่เร็วที่สุดสู่การทำงานอัตโนมัติด้วยเครื่องมือ AI',
  'dashboards.insightsthatempower': 'ข้อมูลเชิงลึกที่มอบพลัง',
  'dashboards.trainchatbot': 'ฝึกแชทบ็อต',
  'dashboards.automatewithforms': 'อัตโนมัติโดยใช้ฟอร์ม',
  'dashboards.inroomdigitalcompendium': 'ศูนย์รวมดิจิทัลในห้องพัก',
  'dashboards.support': 'การสนับสนุน',
  'dashboards.helpcenter': 'ศูนย์ช่วยเหลือ',
  'dashboards.searchfaqintegrations':
    'ค้นหาบทความเกี่ยวกับคำถามที่พบบ่อย การรวมระบบ และอื่นๆ',
  'dashboards.asklivechat': 'ถามคำถามกับทีมของเราผ่านแชทสด',
  'dashboards.inroomqrcode':
    'รหัส QR ในห้องสำหรับดูข้อมูลเกี่ยวกับที่พักและสถานที่',
  'dashboards.customizewebwidget':
    'ปรับแต่งและเพิ่ม Web Widget ไปยังเว็บไซต์ของคุณพร้อม Chatbot AI บูรณาการ',
  'dashboards.createcustomforms':
    'สร้างแบบฟอร์มที่กำหนดเองและรับการแจ้งเตือนเมื่อแขกส่งแบบฟอร์ม',
  'dashboards.trainchatbotproperty':
    'ฝึก Chatbot ด้วยข้อมูลเกี่ยวกับที่พักของคุณ เช่น เวลาเช็คอิน กิจกรรม ฯลฯ',
  'dashboards.chatbotinsights':
    'ดูว่า Chatbot ของคุณมีส่วนร่วมกับแขกอย่างไรและรับข้อมูลเชิงลึกเกี่ยวกับสถิติ เช่น ผู้เยี่ยมชมเว็บไซต์ คำถามที่พบบ่อย และอีกมากมาย',
  'dashboards.addaichatbottoyourwebsite':
    'เพิ่ม AI Chatbot ไปยังเว็บไซต์ของคุณ',

  /* Email Stats */
  'dashboards.thread-summary-title': 'สรุปกระทู้',
  'dashboards.thread-summary-subtitle': 'สรุปอีเมลที่สร้างโดย AI',
  'dashboards.ai-replies-title': 'การตอบกลับโดย AI',
  'dashboards.ai-replies-subtitle': 'การตอบกลับที่สร้างโดย AI',
  'dashboards.total-thread-summary-title': 'สรุปกระทู้ทั้งหมดที่สร้าง',
  'dashboards.total-ai-replies-title': 'การตอบกลับโดย AI ทั้งหมดที่สร้าง',
  'dashboards.total-draft-copied': 'ร่างที่ถูกคัดลอกโดยผู้ใช้',
  'dashboards.urgency': 'ความเร่งด่วน',
  'dashboards.sentiment': 'อารมณ์',
  'dashboards.common-email-reasons': 'เหตุผลทั่วไปของอีเมล',
  'dashboards.topics-in-emails': 'หัวข้อในอีเมล',
  'dashboards.email-assistant-usage': 'การใช้งานผู้ช่วยอีเมล AI',
  'dashboards.usage-by-email-address': 'การใช้งานตามที่อยู่อีเมล',

  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytics',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservations and Bookings',
  'pages.title.tickets': 'Leads and Tickets',
  'pages.title.propinfo': 'Responses',
  'pages.title.discounts': 'Discounts and Promotions',
  'pages.title.finance': 'Finance',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Admin',
  'pages.add-new': 'ADD NEW',
  'pages.add-new-modal-title': 'Add New Item',
  'pages.display-options': 'Display Options',
  'pages.orderby': 'Order By : ',
  'pages.product-name': 'Product Name',
  'pages.category': 'Category',
  'pages.description': 'Description',
  'pages.status': 'Status',
  'pages.cancel': 'Cancel',
  'pages.submit': 'Submit',
  'pages.delete': 'Delete',
  'pages.another-action': 'Another action',
  'pages.actions': 'ACTIONS',
  'pages.header': 'Header',
  'pages.details': 'DETAILS',
  'pages.orders': 'ORDERS',
  'pages.rating': 'Rating',
  'pages.price': 'Price',
  'pages.ingredients': 'Ingredients',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ooops... looks like an error occurred!',
  'pages.error-code': 'Error code',
  'pages.go-back-home': 'GO BACK HOME',
  'pages.mailing-info':
    'Mailing templates use inline styling and table layout to be displayed well at various service providers. To provide better usability we include it as regular html with dangerouslySetInnerHTML.',
  'pages.invoice-info':
    'Invoice template has an inline styled version for usage outside of the project as well as React version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Messages',
  'chat.contacts': 'Contacts',
  'chat.saysomething': 'Say something..',

  /* 06.02.Survey */
  'survey.delete': 'Delete',
  'survey.edit': 'Edit',
  'survey.add-new': 'ADD NEW',
  'survey.add-new-title': 'Add New Survey',
  'survey.title': 'Title',
  'survey.category': 'Category',
  'survey.label': 'Label',
  'survey.status': 'Status',
  'survey.cancel': 'Cancel',
  'survey.submit': 'Submit',
  'survey.another-action': 'Another action',
  'survey.display-options': 'Display Options',
  'survey.orderby': 'Order By : ',
  'survey.all-surveys': 'All Surveys',
  'survey.completed-surveys': 'Completed Surveys',
  'survey.categories': 'Categories',
  'survey.active-surveys': 'Active Surveys',
  'survey.labels': 'Labels',

  /* 06.03.Todo */
  'todo.add-new': 'ADD NEW',
  'todo.add-new-title': 'Add New Todo',
  'todo.title': 'Title',
  'todo.detail': 'Detail',
  'todo.category': 'Category',
  'todo.label': 'Label',
  'todo.status': 'Status',
  'todo.cancel': 'Cancel',
  'todo.submit': 'Submit',
  'todo.action': 'Action',
  'todo.another-action': 'Another action',
  'todo.display-options': 'Display Options',
  'todo.orderby': 'Order By : ',
  'todo.all-tasks': 'All Tasks',
  'todo.pending-tasks': 'Pending Tasks',
  'todo.completed-tasks': 'Completed Tasks',
  'todo.categories': 'Categories',
  'todo.labels': 'Labels',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Rounded Alert',
  'alert.react-notifications': 'React Notifications',
  'alert.outline': 'Outline',
  'alert.primary': 'Primary',
  'alert.secondary': 'Secondary',
  'alert.info': 'Info',
  'alert.success': 'Success',
  'alert.warning': 'Warning',
  'alert.error': 'Error',
  'alert.filled': 'Filled',
  'alert.primary-text': 'This is a primary alert—check it out!',
  'alert.secondary-text': 'This is a secondary alert—check it out!',
  'alert.success-text': 'This is a success alert—check it out!',
  'alert.danger-text': 'This is a danger alert—check it out!',
  'alert.warning-text': 'This is a warning alert—check it out!',
  'alert.info-text': 'This is a info alert—check it out!',
  'alert.light-text': 'This is a light alert—check it out!',
  'alert.dark-text': 'This is a dark alert—check it out!',
  'alert.default': 'Default Alert',
  'alert.dismissing': 'Dismissing Alert',
  'alert.dismissing-text':
    'Holy guacamole! You should check in on some of those fields below.',
  'alert.dismissing-without-animate-text':
    'I am an alert and I can be dismissed without animating!',

  /* 07.02.Badges */
  'badge.sizes': 'Sizes',
  'badge.colors': 'Colors',
  'badge.outline': 'Outline',
  'badge.links': 'Links',
  'badge.counter-badges': 'Counter Badges',
  'badge.bootstrap-default': 'Bootstrap Default',
  'badge.primary': 'Primary',
  'badge.secondary': 'Secondary',
  'badge.success': 'Success',
  'badge.danger': 'Danger',
  'badge.warning': 'Warning',
  'badge.info': 'Info',
  'badge.light': 'Light',
  'badge.dark': 'Dark',

  /* 07.03.Buttons */
  'button.default': 'Bootstrap Default',
  'button.colors': 'Colors',
  'button.rounded': 'Rounded',
  'button.outline': 'Outline',
  'button.states': 'States',
  'button.sizes': 'Sizes',
  'button.button-groups': 'Button Groups',
  'button.large-button': 'Large Button',
  'button.small-button': 'Small Button',
  'button.extra-small-button': 'Extra Small Button',
  'button.block-button': 'Block Button',
  'button.active': 'Active',
  'button.disabled': 'Disabled',
  'button.basic': 'Basic',
  'button.toolbar': 'Toolbar',
  'button.nesting': 'Nesting',
  'button.vertical-variation': 'Vertical Variation',
  'button.checkbox-radio-button': 'Checkbox and Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primary',
  'button.secondary': 'Secondary',
  'button.success': 'Success',
  'button.danger': 'Danger',
  'button.warning': 'Warning',
  'button.info': 'Info',
  'button.light': 'Light',
  'button.dark': 'Dark',
  'button.states-text':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.click-here': 'Click Here',
  'button.states-text-alternate':
    'This button shows a spinner for 2 seconds and an error icon for 3 seconds before switching to normal state. This states can be triggered by adding and removing classes.',
  'button.primary-link': 'Primary Link',
  'button.link': 'Link',
  'button.primary-button': 'Primary Button',
  'button.button': 'Button',
  'button.left': 'Left',
  'button.middle': 'Middle',
  'button.right': 'Right',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown Link',

  /* 07.04.Cards */
  'cards.icon-card': 'Icon Card',
  'cards.image-card': 'Image Card',
  'cards.image-overlay-card': 'Image Overlay Card',
  'cards.image-card-list': 'Image Card List',
  'cards.tab-card': 'Tab Card',
  'cards.user-card': 'User Card',

  /* 07.05.Carousel */
  'carousel.basic': 'Carousel Basic',
  'carousel.single': 'Carousel Single',
  'carousel.without-controls': 'Carousel Without Controls',

  /* 07.06.Charts */
  'charts.line': 'Line Chart',
  'charts.polar': 'Polar Chart',
  'charts.area': 'Area Chart',
  'charts.scatter': 'Scatter Chart',
  'charts.bar': 'Bar Chart',
  'charts.radar': 'Radar Chart',
  'charts.pie': 'Pie Chart',
  'charts.doughnut': 'Doughnut Chart',
  'charts.shadow': 'Shadow',
  'charts.no-shadow': 'No Shadow',

  /* 07.07.Collapse */
  'collapse.basic': 'Basic',
  'collapse.toggle': 'Toggle',
  'collapse.accordion': 'Accordion',
  'collapse.controlled': 'Controlled',
  'collapse.uncontrolled': 'Uncontrolled',

  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basic',
  'dropdowns.controlled': 'Controlled',
  'dropdowns.uncontrolled': 'Uncontrolled',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Header',
  'dropdowns.action': 'Action',
  'dropdowns.another-action': 'Another Action',
  'dropdowns.right': 'Right',
  'dropdowns.left': 'Left',
  'dropdowns.drop-directions': 'Drop Directions',
  'dropdowns.dropright': 'Dropright',
  'dropdowns.dropleft': 'Dropleft',
  'dropdowns.small-button': 'Small Button',
  'dropdowns.large-button': 'Large Button',
  'dropdowns.sizing': 'Sizing',
  'dropdowns.split-button': 'Split Button Dropdowns',
  'dropdowns.dropup': 'Dropup',

  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',

  /* 07.10.Forms */
  'forms.basic': 'Basic',
  'forms.email': 'E-mail',
  'forms.email-muted': "We'll never share your email with anyone else.",
  'forms.password': 'Password',
  'forms.submit': 'Submit',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'First radio',
  'forms.second-radio': 'Second radio',
  'forms.third-radio-disabled': 'Third disabled radio',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Sign in',
  'forms.top-labels-over-line': 'Top Labels Over Line',
  'forms.tags': 'Tags',
  'forms.date': 'Date',
  'forms.state': 'State',
  'forms.top-labels-in-input': 'Top Labels In Input',
  'forms.email-u': 'E-MAIL',
  'forms.password-u': 'PASSWORD',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATE',
  'forms.state-u': 'STATE',
  'forms.grid': 'Form Grid',
  'forms.address': 'Address',
  'forms.address2': 'Address 2',
  'forms.city': 'City',
  'forms.city-message': 'Please select a city!',
  'forms.state-message': 'Please select a state!',
  'forms.zip': 'Zip',
  'forms.signup': 'Signup',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validation',
  'forms.validation-formik': 'Formik Validation',
  'forms.default': 'Default',
  'forms.firstname': 'First name',
  'forms.firstname-message': 'Please enter your first name!',
  'forms.lastname': 'Last name',
  'forms.lastname-message': 'Please enter your last name!',

  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Custom Inputs',
  'form-components.checkboxes': 'Checkboxes',
  'form-components.radios': 'Radios',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'State Single',
  'form-components.state-multiple': 'State Multiple',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Date Picker',
  'form-components.date': 'Date',
  'form-components.date-range': 'Date Range',
  'form-components.date-with-time': 'Date with Time',
  'form-components.embedded': 'Embedded',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Drop Files Here',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Switch',
  'form-components.primary': 'Primary',
  'form-components.secondary': 'Secondary',
  'form-components.primary-inverse': 'Primary Inverse',
  'form-components.secondary-inverse': 'Secondary Inverse',
  'form-components.slider': 'Slider',
  'form-components.double-slider': 'Double Slider',
  'form-components.single-slider': 'Single Slider',
  'form-components.rating': 'Rating',
  'form-components.interactive': 'Interactive',
  'form-components.readonly': 'Readonly',
  'form-components.type-a-cake': 'Type a Cake',
  'form-components.start': 'Start',
  'form-components.end': 'End',
  'form-components.tables': 'Tables',
  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basic',
  'input-groups.sizing': 'Sizing',
  'input-groups.small': 'Small',
  'input-groups.default': 'Default',
  'input-groups.large': 'Large',
  'input-groups.checkboxes-and-radios': 'Checkboxes and radios',
  'input-groups.multiple-inputs': 'Multiple Inputs',
  'input-groups.first-and-last-name': 'First and last name',
  'input-groups.multiple-addons': 'Multiple Addons',
  'input-groups.button-addons': 'Button Addons',
  'input-groups.button': 'Button',
  'input-groups.buttons-with-dropdowns': 'Buttons with Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Header',
  'input-groups.action': 'Action',
  'input-groups.another-action': 'Another Action',
  'input-groups.custom-select': 'Custom Select',
  'input-groups.options': 'Options',
  'input-groups.choose': 'Choose...',
  'input-groups.custom-file-input': 'Custom File Input',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hello, world!',
  'jumbotron.lead':
    'This is a simple hero unit, a simple jumbotron-style component for calling extra attention to featured content or information.',
  'jumbotron.lead-detail':
    'It uses utility classes for typography and spacing to space content out within the larger container.',
  'jumbotron.learn-more': 'Learn more',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modal title',
  'modal.launch-demo-modal': 'Launch Demo Modal',
  'modal.scrolling-long-content': 'Scrolling Long Content',
  'modal.backdrop': 'Backdrop',
  'modal.backdrop-value': 'Backdrop value',
  'modal.right-modal': 'Right Modal',
  'modal.launch-right-modal': 'Launch Right Modal',
  'modal.nested-modal': 'Nested Modal',
  'modal.size': 'Size',
  'modal.launch-large-modal': 'Launch Large Modal',
  'modal.launch-small-modal': 'Launch Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Nav Basic',
  'nav.active': 'Active',
  'nav.disabled': 'Disabled',
  'nav.disabled-link': 'Disabled Link',
  'nav.link': 'Link',
  'nav.longer-link': 'Longer nav link',
  'nav.another-link': 'Another Link',
  'nav.right': 'Right',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Header',
  'nav.action': 'Action',
  'nav.another-action': 'Another Action',
  'nav.horizontal-alignment': 'Nav Horizontal Alignment',
  'nav.vertical-alignment': 'Nav Vertical Alignment',
  'nav.pills': 'Nav Pills',
  'nav.fill-justify': 'Nav Fill and Justify',
  'nav.pills-dropdowns': 'Nav Pills with Dropdowns',
  'nav.pagination-basic': 'Pagination Basic',
  'nav.pagination-sizing': 'Pagination Sizing',
  'nav.large': 'Large',
  'nav.small': 'Small',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Pagination Alignment',
  'nav.breadcrumb-basic': 'Breadcrumb Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Tooltip',

  /* 07.18.Sortable */
  'sortable.columns': 'Sorting Columns',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Handles',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Yandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap Tables',
  'table.bootstrap-basic': 'Basic Table',
  'table.bootstrap-striped': 'Striped Rows',
  'table.bootstrap-bordered': 'Bordered Table',
  'table.bootstrap-borderless': 'Borderless Table',
  'table.bootstrap-hoverable': 'Hoverable Rows',
  'table.bootstrap-responsive': 'Responsive Table',
  'table.react-tables': 'React Tables',
  'table.react-pagination': 'Pagination',
  'table.react-scrollable': 'Scrollable',
  'table.react-advanced': 'Filter, Length and Jump',

  /* Property Info */
  'property-info.allcustomers': 'ลูกค้าทั้งหมด',
  'property-info.external-sources': 'แหล่งข้อมูลภายนอก',
  'property-info.faq': 'คำถามที่พบบ่อย',
  'property-info.documents': 'เอกสาร',
  'property-info.publish-ai': 'เผยแพร่ด้วย AI',
  'property-info.pre-built-templates': 'แม่แบบที่สร้างไว้ล่วงหน้า',
  'property-info.room-types': 'ประเภทห้อง',

  'property-info.about-property': 'เกี่ยวกับอสังหาริมทรัพย์',
  'property-info.about-properties': 'เกี่ยวกับคุณสมบัติ',
  'property-info.facilities-services': 'สิ่งอำนวยความสะดวกและบริการ',
  'property-info.property-facilities': 'สิ่งอำนวยความสะดวกของที่พัก',
  'property-info.room-amenities': 'สิ่งอำนวยความสะดวกในห้องพัก',
  'property-info.property-contact': 'ติดต่อทรัพย์สิน',
  'property-info.property-activities': 'กิจกรรมด้านอสังหาริมทรัพย์',
  'property-info.property-location': 'ที่ตั้งทรัพย์สิน',
  'property-info.about-rooms': 'ห้องพัก',
  'property-info.about-sites': 'เกี่ยวกับไซต์',
  'property-info.special-emergencies': 'กรณีฉุกเฉิน',
  'property-info.gallery': 'แกลเลอรี่',
  'property-info.policies': 'นโยบาย',
  'property-info.nearby': 'ใกล้เคียง',
  'property-info.transport': 'ขนส่ง',
  'property-info.location': 'ที่ตั้ง',
  'property-info.about-rhproperty': 'เกี่ยวกับบ้านพักคนชรา',
  'property-info.related-topics': 'หัวข้อที่เกี่ยวข้อง',
  'property-info.assistant-options': 'เมนูผู้ช่วย',
  'property-info.restaurant-assistant-information': 'ข้อมูลร้านอาหาร',
  'property-info.restaurant-assistant-options': 'ข้อความต้อนรับ',
  'property-info.channel-messages': 'ข้อความช่อง',
  'property-info.icon.gallery': 'ไอคอนแกลลอรี่',
  'property-info.copilot': 'นักบิน',
  'property-info.sprint': 'วิ่ง',
  'property-info.home-information': 'ข้อมูลบ้าน',
  'property-info.loction': 'สถานที่',
  'property-info.rooms-and-images': 'ห้องพักและรูปภาพ',
  'property-info.trainig-data': 'ข้อมูลการฝึกอบรม',
  'property-info.flows': 'กระแส',
  'property-info.add-your-own': 'เพิ่มของคุณเอง',
  'property-info-utility-miscellaneous': 'เบ็ดเตล็ด',
  'property-info-utility-payment': 'การชำระเงิน',
  'property-info-utility-broadband': 'บรอดแบนด์',
  'property-info-utility-emergency': 'ภาวะฉุกเฉิน',
  'property-info-utility-mobile': 'มือถือ',
  'property-info-utility-moving': 'การย้าย',
  'property-info.publishMonitor': 'เผยแพร่และตรวจสอบ',
  'property-info.webWidget': 'วิดเจ็ตเว็บ',
  'property-info.media': 'สื่อ',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'แผนอัตรา',
  'rate-promo.rate-plan-addons': 'ส่วนเสริม',
  'rate-promo.rate-plan-promos': 'โปรโมชั่น',

  'title.property-information': 'ข้อมูลทรัพย์สิน',

  'property.message': 'ข้อความ',
  'property.example': 'ตัวอย่าง',
  'property.link': 'ลิงค์',
  'property.image-carousel': 'ภาพหมุน',
  'property.Title': 'ชื่อ',
  'property.SubTitle': 'หัวข้อย่อย',

  'property.add-invoke-api': 'เรียกใช้ Api',
  'property.add-message-button': 'เพิ่มข้อความ',
  'property.add-img-button': 'เพิ่มรูปภาพ',
  'property.add-link-button': 'เพิ่มลิงค์',
  'property.add-herocard-button': 'เพิ่มการ์ดฮีโร่',
  'property.add-api-button': 'เพิ่มปุ่ม',

  'menu.settings': 'การตั้งค่า',
  'menu.workflows': 'เวิร์กโฟลว์',
  'menu.product_services': 'สินค้า & บริการ',
  'menu.product_recommander': 'ผู้แนะนำสินค้า',
  'menu.digital_guide_book': 'คู่มือดิจิทัล',
  'menu.welcome_message': 'ข้อความต้อนรับ',
  'menu.about-property': 'เกี่ยวกับทรัพย์',
  'menu.property-facilities': 'สิ่งอำนวยความสะดวกของทรัพย์',
  'menu.room-amenities': 'สิ่งอำนวยความสะดวกในห้อง',
  'menu.property-contact': 'ติดต่อทรัพย์',
  'menu.about-rooms': 'ห้องพัก',
  'menu.special-emergencies': 'กรณีฉุกเฉิน',
  'menu.show-filter': 'ตัวกรอง',
  'menu.new': 'ใหม่',
  'menu.channel': 'ช่องทาง',
  'menu.application': 'แอปพลิเคชัน',
  'menu.content-manager': 'ผู้จัดการเนื้อหา',
  'menu.events-calendar': 'ปฏิทินกิจกรรม',
  'menu.appearance-settings': 'ลักษณะ & การตั้งค่า',

  'dashboards.send': 'ส่ง',
  'dashboards.hello': 'สวัสดี',
  'dashboards.notificationsAllowed': 'อนุญาตการแจ้งเตือน',
  'dashboards.allowNotifications': 'อนุญาตการแจ้งเตือน',
  'dashboards.views': 'จำนวนดู',
  'dashboards.bookingURL': 'URL การจอง',
  'dashboards.searchTags': 'แท็กการค้นหา',
  'dashboards.searchCategoryTags': 'แท็กหมวดการค้นหา',
  'dashboards.bedroom': 'ห้องนอน',
  'dashboards.addBedroom': 'เพิ่มห้องนอน',
  'dashboards.frequency': 'ความถี่',
  'dashboards.includeSubpages': 'รวมหน้าเว็บไซต์ย่อย',
  'dashboards.enableFaqs': 'เปิดใช้งานคำถามที่พบบ่อย',
  'dashboards.faqsDescription':
    'การเปิดใช้งาน FAQs จะช่วยให้คุณป้อนคำถามในขณะที่ระบบดึงคำตอบที่ตรงกันจากเนื้อหาของหน้าเว็บเพื่อสร้าง FAQ ที่สมบูรณ์',
  'dashboards.faq': 'คำถามที่พบบ่อย',
  'dashboards.deleteDocument': 'ลบเอกสาร',
  'dashboards.confirmDelete': 'คุณแน่ใจหรือไม่ว่าต้องการลบ?',
  'dashboards.addItem': 'เพิ่มรายการ',
  'dashboards.addFirstWebPage': 'เพิ่มหน้าเว็บแรกของคุณ',

  'dashboards.popular-compendium': '	รายการเมนู Compendium ยอดนิยม',
  'dashboards.wordcloudofcompendium': 'คลาวด์คำของรายการเมนู Compendium',
  'dashboards.wordcloudonthings':
    'คลาวด์คำเกี่ยวกับสิ่งที่ผู้เยี่ยมชมเว็บไซต์ถามและรายการเมนู',
  'dashboards.common-asked': 'คำถามที่พบบ่อย',
  'dashboards.website-visitor-asking': 'สิ่งที่ผู้เยี่ยมชมเว็บไซต์กำลังถามถึง',
  'dashboards.visit-country': 'การเข้าชมเว็บไซต์ตามประเทศ',
  'dashboards.visit-traffic': 'ประเทศของการเข้าชมเว็บไซต์',
  'dashboards.rooms-product': 'ห้องพักและผลิตภัณฑ์',
  'dashboards.popular-room-product': 'ห้องพักและผลิตภัณฑ์ยอดนิยม',

  'dashboards.messenger-stats': 'รายการเมนูยอดนิยม',
  'dashboards.messenger-stats-topic-view': 'สถิติในการดูรายการเมนู',
  'dashboards.messenger-stats-visits': 'มุมมองรายการเมนู',
  'dashboards.opening-menu-items': 'จำนวนผู้เยี่ยมชมเว็บไซต์ที่เปิดรายการเมนู',

  'dashboards.number-totalavatarclick': 'การคลิกรูปประจำตัวทั้งหมด',
  'dashboards.subscribe-to-reports': 'สมัครรับรายงาน',
  'dashboards.clicks': 'จำนวนคลิก',
  'dashboards.leads': 'โอกาสในการขาย',
  'dashboards.hours': 'ชั่วโมง',
  'dashboards.minutes': 'นาที',
  'dashboards.connect': 'เชื่อมต่อ',
  'dashboards.ai-chatbot': 'เอไอ แชทบอท',
  'dashboards.compendium': 'บทสรุป',
  'dashboards.compendium-digital-usage': 'การใช้บทสรุปดิจิทัล',
  'dashboards.compendium-unique-visits': 'การสแกน/คลิก QR code',
  'dashboards.compendium-opening-menu-items': 'จำนวนรายการเมนูที่ดู',
  'dashboards.compendium-total-digital-clicks': 'มุมมองรายการเมนูทั้งหมด',
  'dashboards.compendium-total-qr-code': 'จำนวนการสแกน/คลิก QR code ทั้งหมด',
  'dashboards.compendium-avg-menu-items': 'การดูรายการเมนูเฉลี่ยต่อการสแกน',
  'dashboards.top-clicked-urls': 'URL ที่ถูกคลิกมากที่สุด',
  'dashboards.top-clicked-urls-description': 'การวิเคราะห์การคลิก URL',
  'dashboards.urls': 'URL',
  'dashboards.externalDeleteMessage':
    'เอกสารนี้ถูกสร้างจากแหล่งภายนอก หากคุณไม่ต้องการให้สร้างขึ้นอีก โปรดลบตารางการซิงค์ที่เกี่ยวข้องด้วย',
  'dashboards.deleteAndGoToExternalSources': 'ลบและไปยังแหล่งภายนอก',
  'dashboards.tickets-by-category': 'ตั๋วตามหมวดหมู่',
  'dashboards.download': 'ดาวน์โหลด',
  'property.delete': 'ลบ',
  'menu.userroles': 'ผู้ใช้และบทบาท',
  'menu.members': 'สมาชิก',
  'menu.guest-pass': 'บัตรผ่านสำหรับแขก',
  'menu.ratebookings': 'ราคาและการจอง',
  'dashboards.engagement-time': 'เวลาการมีส่วนร่วมของผู้ช่วยดิจิทัล',
  'dashboards.conversations-minutes':
    'นาทีรวมและข้ามคืน (19.00 น. ถึง 07.00 น.) นาทีการสนทนา',
  'dashboards.visitor-questions': 'คำถามของผู้เยี่ยมชม',
  'dashboards.recent-queries': 'แบบสอบถามล่าสุด',
  'dashboards.visitor-saying': 'ผู้เยี่ยมชมของคุณพูดอะไรกับ Digital Assistant',
  'dashboards.contacts-prechatform-leavemessage':
    'รายชื่อติดต่อที่เก็บไว้จากแบบฟอร์มแชทล่วงหน้าและฝากข้อความ',
  'menu.dashboards': 'ข้อมูลเชิงลึก',
  'menu.ari': 'ห้องว่างและราคา',
  'menu.conversations': 'บทสนทนา',
  'menu.conversations.unified-inbox': 'กล่องจดหมายแบบรวม',
  'menu.conversations.active': 'แชทที่ใช้งานอยู่',
  'menu.conversations.archives': 'หอจดหมายเหตุ',
  'menu.conversations.missed-responses': 'การตอบกลับที่ไม่ได้รับ',
  'menu.conversations.ticket': 'ตั๋ว',
  'menu.conversations.reply-templates': 'ตอบกลับเทมเพลต',
  'menu.bookings': 'การจองและการจอง',
  'menu.tickets': 'ข้อมูลลูกค้าเป้าหมายและตั๋ว',
  'menu.propinfo': 'ศูนย์กลางความรู้',
  'menu.rate-promos': 'อัตราและโปรโมชั่น',
  'menu.finance': 'การเงิน',
  'menu.integration': 'เชื่อมต่อ',
  'menu.admin': 'ผู้ดูแลระบบและความปลอดภัย',
  'menu.favourites': 'รายการโปรด',
  'menu.recommender': 'กระแสการสนทนา',
  'menu.assistant-setup': 'การตั้งค่าผู้ช่วย',
  'menu.admin-insights': 'ข้อมูลเชิงลึกของผู้ดูแลระบบ',
  'menu.super-admin': 'ผู้ดูแลระบบขั้นสูง',
  'menu.groups': 'กลุ่ม',
  'menu.properties': 'คุณสมบัติ',
  'menu.service-provider': 'ผู้ให้บริการ',
  'menu.spaces': 'ช่องว่าง',
  'menu.availability': 'ความพร้อมใช้งาน',
  'menu.help': 'ความช่วยเหลือ',
  'menu.myAccounts': 'บัญชีของฉัน',

  'menu.guest-messaging': 'ข้อความสำหรับแขก',
  'guest-messaging.settings': 'การตั้งค่า',
  'guest-messaging.outreach-setup': 'ตั้งค่าการเข้าถึง',
  'guest-messaging.reservations': 'การจอง',
  'guest-messaging.insights_logs': 'ข้อมูลเชิงลึกและบันทึก',

  'guest-messaging.placeholder': 'โมดูลข้อความสำหรับแขกจะมาเร็ว ๆ นี้',
  'guest-messaging.settings.placeholder': 'ตั้งค่าข้อความสำหรับแขก',
  'guest-messaging.outreach.placeholder': 'ตั้งค่าแคมเปญเข้าถึงและแม่แบบ',
  'guest-messaging.reservations.placeholder': 'จัดการข้อความการจอง',

  'guest-messaging.reservation-source': 'แหล่งข้อมูลการจอง',
  'guest-messaging.communication-channels': 'ช่องทางการสื่อสาร',
  'guest-messaging.templates': 'แม่แบบ',
  'guest-messaging.link': 'ลิงก์',
  'guest-messaging.business-profile': 'ข้อมูลธุรกิจ',

  'dashboards.space-booking': 'การจองพื้นที่',
  'dashboards.gift-voucher': 'บัตรกำนัล',
  'dashboards.chatbots': 'แชทบอท',
  'dashboards.form': 'จาก',
  'dashboards.to': 'ถึง',
  'dashboards.active-groups': 'กลุ่มที่ใช้งานอยู่',
  'dashboards.active-properties': 'คุณสมบัติที่ใช้งานอยู่',
  'dashboards.live-properties': 'คุณสมบัติสด',
  'dashboards.properties-going': 'คุณสมบัติที่ใช้งานจริงตามช่วงวันที่',
  'dashboards.start-date': 'วันที่เริ่มต้น',
  'dashboards.end-date': 'วันที่สิ้นสุด',

  'dashboards.website-visits': 'การเข้าชมเว็บไซต์',
  'dashboards.unique-visitors': 'ผู้เยี่ยมชมที่ไม่ซ้ำ',
  'dashboards.last-week': 'อาทิตย์ที่แล้ว',
  'dashboards.this-week': 'ในสัปดาห์นี้',
  'dashboards.this-month': 'เดือนนี้',
  'dashboards.previous-month': 'เดือนที่แล้ว',
  'dashboards.yeartodate': 'ปีถึงวัน',
  'dashboards.lastyear': 'ปีที่แล้ว',
  'dashboards.last-7-days': '7 วันที่ผ่านมา',
  'dashboards.last-30-days': '30 วันที่ผ่านมา',
  'dashboards.last-60-days': '60 วันที่ผ่านมา',
  'dashboards.last-90-days': '90 วันที่ผ่านมา',
  'dashboards.conversion-rates': 'อัตราการแปลง',
  'dashboards.digital-assistant-engagement': 'การมีส่วนร่วมของผู้ช่วยดิจิทัล',
  'dashboards.total-overnight-conversations':
    'การสนทนาทั้งหมดและข้ามคืน (19.00 น. ถึง 07.00 น.)',
  'dashboards.percentage-accuracy': 'ความครอบคลุมของความรู้',
  'dashboards.percentage-conversion': 'การเข้าชมเว็บไซต์สู่การแปลงการแชท',
  'dashboards.percentage-avatarclick': 'การเข้าชมเว็บไซต์สู่การคลิก Avatar',
  'dashboards.percentage-negativefeedback':
    'ผลตอบรับเชิงลบเป็น %อายุของการคลิกอวาตาร์',
  'dashboards.percentage-amenties': 'แบบสอบถามสิ่งอำนวยความสะดวก',
  'dashboards.percentage-booking': 'สอบถามข้อมูลการจอง',
  'dashboards.percentage-webchats': 'แชทเว็บไซต์',
  'dashboards.percentage-facebookchat': 'แชทเฟสบุ๊ค',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': 'เวลาสนทนาทั้งหมด',
  'dashboards.number-totalconversation': 'บทสนทนาทั้งหมด',
  'dashboards.number-websiteconversation': 'การสนทนาบนเว็บไซต์',
  'dashboards.number-facebookconversation': 'การสนทนาบน Facebook',
  'dashboards.number-estimatedtimesaving': 'ประหยัดเวลาโดยประมาณ',
  'dashboards.number-googlemapsconversation': 'การสนทนาของ Google แผนที่',
  'dashboards.number-whatsappconversation': 'การสนทนา WhatsApp',
  'dashboards.number-instagramconversation': 'บทสนทนาบนอินสตาแกรม',
  'dashboards.number-agentconversation': 'การสนทนาของตัวแทน',
  'dashboards.number-amenityqueries': 'แบบสอบถามสิ่งอำนวยความสะดวก',
  'dashboards.number-bookingenquiries': 'สอบถามการจอง',
  'dashboards.number-groupbookingenquiries': 'สอบถามการจองแบบหมู่คณะ',
  'dashboards.number-eventenquiries': 'สอบถามข้อมูลกิจกรรม',
  'dashboards.number-longstayenquiries': 'สอบถามข้อมูลการเข้าพักระยะยาว',
  'dashboards.number-totaltickets': 'ตั๋ว',
  'dashboards.number-returncustomer': 'ส่งคืนลูกค้า',
  'dashboards.number-redirects': 'การเปลี่ยนเส้นทางเว็บไซต์',
  'dashboards.number-bookingengineleads': 'ผู้นำด้านระบบการจอง',
  'dashboards.number-roomnightsreferred': 'ห้องพักคืนอ้างอิง',
  'dashboards.number-revenuereferred': 'รายได้ที่อ้างถึง',
  'menu.bookingsmenu': 'การจอง',
  'menu.guests': 'ข้อมูลแขก',
  'menu.whatsnew': 'มีอะไรใหม่',

  'menu.formbuilder': 'ตัวสร้างแบบฟอร์ม',
  'forms.forms-title': 'แบบฟอร์ม',
  'dashboards.trainAI': 'ฝึก AI ด้วยเอกสาร',
  'dashboards.uploadDocuments':
    'อัปโหลดเอกสารเพื่อช่วยให้ AI ของคุณเรียนรู้เกี่ยวกับธุรกิจของคุณและช่วยเหลือลูกค้าเช่นเดียวกับที่คุณทำ คุณสามารถเพิ่มไฟล์ในรูปแบบ .doc, .pdf หรือ .txt ได้',
  'dashboards.welcomeMessage': 'ข้อความต้อนรับ',
  'dashboards.personalizeGreeting':
    'ปรับแต่งวิธีการทักทายลูกค้าให้สะท้อนถึงแบรนด์ สไตล์ และมารยาทของคุณ เพื่อให้ลูกค้าได้รับการต้อนรับอย่างอบอุ่นที่สุด ปรับแต่งคำทักทายให้สะท้อนแบรนด์ของคุณและสร้างความประทับใจแรกที่อบอุ่น',
  'dashboards.addRoomDetails':
    'เพิ่มรายละเอียดเกี่ยวกับห้องแต่ละห้องของคุณเพื่อให้แขกสามารถค้นพบทุกสิ่งที่พวกเขาต้องการได้อย่างง่ายดาย เพื่อเลือกที่พักที่เหมาะสมที่สุดและทำให้กระบวนการจองง่ายและเร็วขึ้น',
  'dashboards.trainAIFAQs': 'ฝึก AI ด้วย คำถามที่พบบ่อย',
  'dashboards.manualQuestions':
    'คำถามบางข้อไม่สามารถตอบได้โดยเอกสารหรือพบในเว็บไซต์ ที่นี่ คุณสามารถเพิ่มคำถามด้วยตนเองเพื่อให้แน่ใจว่าลูกค้ามีข้อมูลที่ต้องการอยู่ในมือเสมอ',
  'dashboards.publishAI': 'เผยแพร่ AI เพื่อสะท้อนการอัปเดตล่าสุด',
  'dashboards.retrainAfterChanges':
    'เมื่อคุณทำการเปลี่ยนแปลงใน Knowledge Hub หรือแบบฟอร์ม ให้แน่ใจว่าได้ฝึกซ้ำแชทบ็อตด้วยข้อมูลที่อัปเดต การเผยแพร่ AI ของคุณช่วยให้แชทบ็อตให้คำตอบที่แม่นยำและอัปเดตที่สุด',
  'dashboards.enhanceKnowledge':
    'เพิ่มพูนความรู้ AI โดยติดตามคำถามที่ยังไม่มีคำตอบ',
  'dashboards.reviewUnanswered':
    'เมื่อใดที่ AI ไม่สามารถตอบคำถามได้หรือให้รายละเอียดเพียงเล็กน้อยเท่านั้น คุณจะพบคำถามเหล่านั้นที่นี่ ตรวจสอบเพื่อระบุช่องว่างใน Knowledge Hub ของคุณหรือคำถามเฉพาะจากแขก',
  'dashboards.manageMedia': 'จัดการสื่อ',
  'dashboards.mediaGallery':
    'เมื่อคุณอัปโหลดภาพ เช่น ห้องพัก สิ่งอำนวยความสะดวก โลโก้ หรืออวาตาร์ดิจิทัลของคุณ ภาพเหล่านั้นจะแสดงในแกลเลอรี่นี้ มอบที่เก็บศูนย์กลางสำหรับจัดการภาพและมั่นใจว่าสมาชิกของคุณจะได้เห็นสิ่งที่ทำให้ธุรกิจของคุณโดดเด่น',
  'dashboards.createForms':
    'สร้างรูปแบบได้อย่างง่ายดายและรับการแจ้งเตือนเมื่อมีการส่งทุกครั้ง',
  'dashboards.manageForms':
    'สร้างและจัดการฟอร์มเพื่อรวบรวมข้อมูลลูกค้า ตั้งค่าการแจ้งเตือน และปรับแต่งให้รองรับหลายภาษา',
  'dashboards.personalizeResponse':
    'ปรับแต่งสไตล์การตอบกลับและวิธีการดำเนินการสนทนา',
  'dashboards.controlConversation':
    'ฟีเจอร์ขั้นสูงนี้ช่วยให้คุณมีความสามารถในการกำหนดและควบคุมวิธีที่บทสนทนาคลี่คลายกับลูกค้าของคุณผ่านช่องทางต่าง ๆ',

  'menu.virtualfrontdesk': 'แผนกต้อนรับเสมือน',
  'menu.guestservice': 'บริการแขก',
  'virtual-front.common-questions': 'คำถามทั่วไป',
  'virtual-front.add-on-upsells': 'ส่วนเสริมและการขายต่อยอด',
  'virtual-front.service-order': 'คำสั่งบริการ',
  // 'virtual-front.guest-service-add-on-upsells': "Guest Services & Add-on's",
  'virtual-front.guest-service-add-on-upsells': 'บทสรุปดิจิทัล',
  'virtual-front.outbound': 'ขาออก',
  'virtual-messenger': 'Web Widget Menus',

  'missed-response.missed-response-title': 'หัวข้อการตอบกลับที่ไม่ได้รับ',
  //
  'content.allconversation': 'การสนทนาทั้งหมด',
  'content.active': 'ใช้งานอยู่',
  'content.tickets': 'ตั๋ว',
  'content.filter': 'ตัวกรอง',
  'content.createtickets': 'สร้างตั๋ว',
  'content.conversation': 'บทสนทนา',
  'content.knowledgesearch': 'ค้นหาความรู้',
  'content.reply': 'ตอบกลับ',
  'content.visitorinfo': 'ข้อมูลผู้เยี่ยมชม',
  'content.callinfo': 'ข้อมูลการโทร',
  'content.allinsights': 'ข้อมูลเชิงลึกทั้งหมด',
  'content.availabilityrates': 'ความพร้อมใช้งานและอัตราค่าบริการ',
  'content.callback': 'โทรกลับ',
  'content.close': 'ปิด',
  'content.sms': 'SMS',
  'content.timestamp': 'เวลาบันทึก',
  'content.topics': 'หัวข้อ',
  'content.callingparty': 'ผู้โทร',
  'content.accountdomain': 'โดเมนบัญชี',
  'content.calledparty': 'ผู้รับสาย',
  'content.recording': 'การบันทึก',
  'content.phonesystemoriginationcallid': 'รหัสการโทรต้นทางระบบโทรศัพท์',
  'content.phonesystemterminationcallid': 'รหัสการโทรปลายทางระบบโทรศัพท์',
  'content.uniqueconversationid': 'รหัสบทสนทนาเฉพาะ',
  'content.regenerateinsights': 'สร้างข้อมูลเชิงลึกใหม่',
  'content.customersentiment': 'ความรู้สึกของลูกค้า',
  'content.neutral': 'เป็นกลาง',
  'content.customerreportedbroadbandoutage':
    'ลูกค้ารายงานการขัดข้องของบรอดแบนด์โดยให้รหัสลูกค้าและวันที่เปิดใช้บริการเพื่อขอความช่วยเหลือ',
  'content.conversationinsights': 'ข้อมูลเชิงลึกของบทสนทนา',
  'content.broadbandoutage': 'การขัดข้องบรอดแบนด์',
  'content.customeridverification': 'การตรวจสอบรหัสลูกค้า',
  'content.serviceactivationdate': 'วันที่เปิดใช้บริการ',
  'content.followups': 'การติดตามผล',
  'content.actionneeded': 'ต้องดำเนินการ',
  'content.uniqueConversationId': 'รหัสการสนทนาเอกลักษณ์',
  'content.uniqueChatId': 'รหัสแชทเอกลักษณ์',
  'content.recording&transcript': 'การบันทึกและถอดเสียง',
  'content.chatinsights': 'ข้อมูลเชิงลึกแชท',
  'content.visitedpages': 'หน้าที่เข้าชม',
  'content.deviceinfo': 'ข้อมูลอุปกรณ์',
  'content.chatstartedonthispage': 'เริ่มแชทบนหน้านี้',
  'content.prechatinfo': 'ข้อมูลก่อนแชท',
  'content.notes': 'บันทึก',
  'content.reassign': 'มอบหมายใหม่',
  'content.open': 'เปิด',
  'content.dismiss': 'ปิด',
  'content.add_placeholder': 'เพิ่มค่าตัวแทน',
  'content.mobile_number': 'หมายเลขโทรศัพท์มือถือ',
  'content.please_select': 'กรุณาเลือก',
  'content.sendwhatsapp': 'ส่งข้อความ WhatsApp',

  /* Missed Response */
  'feedback.missed-question': 'คำถามที่พลาดไป',
  'feedback.conversation-summary': 'สรุปบทสนทนา',
  'feedback.dates-in-spanish': 'วันที่ต้องเป็นภาษาสเปน',
  'feedback.resolve': 'แก้ไข',
  'feedback.ignore': 'ละเว้น',

  //integration
  // th-TH
  'integration.select_properties': 'เลือกคุณสมบัติ',
  'integration.select_properties_enabled':
    'เลือกคุณสมบัติที่เปิดใช้งานผ่านการรวมนี้',
  'integration.services_addons': 'เลือกบริการ & ส่วนเสริม',
  'integration.services_visible':
    'เลือกว่าบริการ & ส่วนเสริมใดที่จะแสดงในหน้านี้',
  'integration.appearance': 'รูปลักษณ์',
  'integration.appearance_customize':
    'เลือกชื่อผู้ช่วยดิจิทัลของคุณ, avatar และตั้งค่าสีของคุณ',
  'integration.booking_calendar': 'ปฏิทินการจอง',
  'integration.booking_calendar_style': 'เลือกสไตล์สำหรับป็อปอัปปฏิทินการจอง',
  'integration.nudges': 'การกระตุ้น',
  'integration.nudges_setup':
    'ตั้งค่าข้อความเชิงรุกเพื่อดึงดูดผู้เยี่ยมชมเว็บไซต์',
  'integration.position': 'ตำแหน่ง',
  'integration.position_control': 'ควบคุมตำแหน่งวิดเจ็ตแชทบนเว็บไซต์ของคุณ',
  'integration.custom_fonts': 'ฟอนต์ที่กำหนดเอง',
  'integration.custom_fonts_upload':
    'อัปโหลดฟอนต์ที่กำหนดเองที่คุณต้องการใช้สำหรับหน้า',
  'integration.custom_css': 'CSS ที่กำหนดเอง',
  'integration.custom_css_usage':
    'ใช้ CSS เพื่อปรับแต่ง Compendium ดิจิทัลของคุณ',
  'integration.location': 'ตำแหน่ง',
  'integration.location_embed': 'เพิ่ม URL ฝังตำแหน่งของคุณ',
  'integration.external_links': 'ลิงก์ภายนอก',
  'integration.external_links_add': 'เพิ่มลิงก์ของคุณ',
  'integration.language': 'ภาษา',
  'integration.widget_languages': 'เลือกภาษาสำหรับวิดเจ็ตแชท',
  'integration.chatbot_contact': 'แชทบอท ',
  'integration.chatbot_enable': 'เปิดใช้งานผู้ช่วยดิจิทัลของคุณ',
  'integration.chatbot_security': 'รักษาความปลอดภัย Messenger ของคุณ',
  'integration.chatbot_trusted_pages': 'ระบุเพจที่เชื่อถือได้เพื่อแสดงแชทบอท',
  'integration.chatbot_publish': 'เผยแพร่ผู้ช่วยดิจิทัลของคุณ',
  'integration.chatbot_install':
    'คัดลอกโค้ดสคริปต์เพื่อติดตั้งผู้ช่วยดิจิทัลของคุณ',
  'integration.google_analytics': 'การติดตาม Google Analytics',
  'integration.google_analytics_desc':
    'ติดตามกิจกรรมผู้ใช้ เซสชัน และการดำเนินการสำคัญในเว็บวิดเจ็ตด้วย GA4',
  'integration.enable_ga4': 'เปิดใช้งาน Google Analytics',
  'integration.ga4_measurement_id': 'รหัสการวัด GA4',
  'integration.ga4_id_example': 'ตัวอย่าง: G-ABCD123456',
  'integration.track_events': 'ติดตามเหตุการณ์',
  'integration.track_events_desc':
    'เลือกการกระทำของผู้ใช้ที่จะส่งเป็นเหตุการณ์ GA4',
  'integration.avatar_click': 'คลิกอวาตาร์',
  'integration.avatar_click_desc': 'ติดตามเมื่อผู้ใช้คลิกอวาตาร์แชท',
  'integration.menu_click': 'คลิกเมนู',
  'integration.menu_click_desc': 'ติดตามเมื่อผู้ใช้เปิดเมนูเว็บวิดเจ็ต',
  'integration.chat_started': 'เริ่มแชท',
  'integration.chat_started_desc':
    'ติดตามข้อความแรกของผู้ใช้หนึ่งครั้งต่อเซสชัน',
  'integration.event_tag': 'แท็กเหตุการณ์',
  'integration.event_prefix': 'คำนำหน้าเหตุการณ์',
  'integration.final_tag': 'แท็กสุดท้าย',
  'integration.example_event': 'ตัวอย่างเหตุการณ์',
  'integration.once_per_session': 'เพียงครั้งเดียวต่อเซสชัน',
  'integration.saving': 'กำลังบันทึก...',
  'integration.save_ga4_settings': 'บันทึกการตั้งค่า GA4',
};
export default thMessages;
